// Phase 6 — "are there active jobs right now?" reading.
//
// The Analytics screen uses this to decide whether to engage its
// 30-second auto-refresh tick. We piggyback on ``useStatus``
// (already polled every 5 s) so we don't open a second polling
// pipeline — the counts dictionary it returns has everything we
// need to derive the boolean.
//
// "Active" = PENDING OR SUBMITTED. SUBMITTED jobs are in flight
// on PPP and will land a new residual when they finish; PENDING
// jobs will become SUBMITTED next scheduler tick. DONE/FAILED/
// CANCELLED jobs are terminal — no new residuals coming.

import { useStatus } from './useStatus';

export function useActiveJobsIndicator(): { hasActiveJobs: boolean } {
  const { data } = useStatus();
  const pending = data?.counts?.pending ?? 0;
  const submitted = data?.counts?.submitted ?? 0;
  return { hasActiveJobs: pending + submitted > 0 };
}
